<div class="container-fluid">
  <div class="row">
    <div class="col-md-6 offset-md-3 col-lg-4 offset-lg-4 px-0">
      <nav class="navbar sticky-top main-nav px-3">
        <span
          class="back-button f-18 border-0 primary-font-bold mb-4"
          aria-label="Back navigation"
        >
          <!-- <img src="/assets/icons/back-btn.svg" alt="back" class="mr-2" /> -->
          Awaiting payment
        </span>
      </nav>

      <div class="page-content px-3">
        <section class="awaiting-payment">
          <div class="awaiting-payment__card text-center">
            <img src="/assets/icons/awaiting-offline-payment.svg" alt="" />
            <p class="primary-font-medium mt-3">Awaiting offline payment</p>
            <p class="primary-font-normal f-14 mb-4">
              A waiter would attend to you shortly to collect your payment.
              Please prepare either cash or your debit card.
            </p>

            <button
              class="btn btn-pay-online primary-font-normal"
              (click)="goForOnlinePayment()"
            >
              <img src="/assets/icons/online-payment.svg" alt="" />
              Pay online instead
            </button>
          </div>
        </section>
      </div>
    </div>
  </div>
</div>
